import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, CircularProgress } from '@material-ui/core';
import api from '../../../services/api';
import logoimage from '../../../files/images/logo.png';

const periodLabels: Record<string, string> = {
  today: 'Hoje',
  week: 'Semana',
  month: 'Mês',
  year: 'Ano',
};

function formatCurrency(value: number) {
  return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export default function ShareCard() {
  const { token } = useParams<{ token: string }>();
  const [data, setData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get(`/share/${token}`)
      .then(res => {
        setData(res.data);
        setLoading(false);
      })
      .catch(() => {
        setError('Card não encontrado.');
        setLoading(false);
      });
  }, [token]);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1E2141' }}>
        <CircularProgress />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#1E2141', color: '#fff' }}>
        <Typography variant="h5">{error || 'Erro ao carregar card.'}</Typography>
      </div>
    );
  }

  const { ProfitAndLoss, WinAndLoss, period, periodDateRange } = data;
  const isPositive = ProfitAndLoss.total >= 0;

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      background: '#1E2141',
      padding: '20px',
    }}>
      <div style={{
        background: '#2C325C',
        borderRadius: '16px',
        padding: '32px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <a href="https://dashtrader.com.br" target="_blank" rel="noopener noreferrer">
            <img alt="DashTrader" src={logoimage} style={{ width: '180px', marginBottom: '8px' }} />
          </a>
          <Typography variant="h6" style={{ color: '#ffffffcc' }}>
            Resultado — {periodLabels[period] || period}
          </Typography>
        </div>

        <div style={{
          background: '#1E2141',
          borderRadius: '12px',
          padding: '20px',
          textAlign: 'center',
          marginBottom: '16px',
        }}>
          <Typography variant="h3" style={{
            color: isPositive ? '#4BDC4B' : '#FF6347',
            fontWeight: 700,
          }}>
            {formatCurrency(ProfitAndLoss.total)}
          </Typography>
          <Typography variant="body2" style={{ color: '#ffffff99', marginTop: '4px' }}>
            Resultado total
          </Typography>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
          <div style={{
            flex: 1,
            background: '#1E2141',
            borderRadius: '12px',
            padding: '14px',
            textAlign: 'center',
          }}>
            <Typography variant="h6" style={{ color: '#4BDC4B' }}>
              {formatCurrency(ProfitAndLoss.profit)}
            </Typography>
            <Typography variant="caption" style={{ color: '#ffffff99' }}>Lucro</Typography>
          </div>
          <div style={{
            flex: 1,
            background: '#1E2141',
            borderRadius: '12px',
            padding: '14px',
            textAlign: 'center',
          }}>
            <Typography variant="h6" style={{ color: '#FF6347' }}>
              {formatCurrency(ProfitAndLoss.loss)}
            </Typography>
            <Typography variant="caption" style={{ color: '#ffffff99' }}>Perda</Typography>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginBottom: '24px' }}>
          <div style={{
            flex: 1,
            background: '#1E2141',
            borderRadius: '12px',
            padding: '14px',
            textAlign: 'center',
          }}>
            <Typography variant="h6" style={{ color: '#4BDC4B' }}>{WinAndLoss.win}</Typography>
            <Typography variant="caption" style={{ color: '#ffffff99' }}>Wins</Typography>
          </div>
          <div style={{
            flex: 1,
            background: '#1E2141',
            borderRadius: '12px',
            padding: '14px',
            textAlign: 'center',
          }}>
            <Typography variant="h6" style={{ color: '#FF6347' }}>{WinAndLoss.loss}</Typography>
            <Typography variant="caption" style={{ color: '#ffffff99' }}>Losses</Typography>
          </div>
          <div style={{
            flex: 1,
            background: '#1E2141',
            borderRadius: '12px',
            padding: '14px',
            textAlign: 'center',
          }}>
            <Typography variant="h6" style={{ color: '#ffee58' }}>
              {WinAndLoss.percent ? `${WinAndLoss.percent}%` : '—'}
            </Typography>
            <Typography variant="caption" style={{ color: '#ffffff99' }}>Win Rate</Typography>
          </div>
        </div>

        {periodDateRange && (
          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <Typography variant="body2" style={{ color: '#ffffff66', fontStyle: 'italic' }}>
              {periodDateRange}
            </Typography>
            <a href="https://dashtrader.com.br" target="_blank" rel="noopener noreferrer" style={{ color: '#ffffff66', textDecoration: 'none' }}>
              <Typography variant="caption" style={{ color: 'inherit' }}>
                dashtrader.com.br
              </Typography>
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
